module.exports = __webpack_public_path__ + "static/media/buy_customer_support_1.afda4730.png";